<template>
  <svg class="components-icon" xmlns="http://www.w3.org/2000/svg" width="12.945" height="12.938" viewBox="0 0 12.945 12.938">
    <path data-name="Path 261" d="M9.848,10.252v4.109a.687.687,0,0,0,.685.685h4.109a.687.687,0,0,0,.685-.685V10.252a.687.687,0,0,0-.685-.685H10.533A.687.687,0,0,0,9.848,10.252ZM3.685,15.046H7.794a.687.687,0,0,0,.685-.685V10.252a.687.687,0,0,0-.685-.685H3.685A.687.687,0,0,0,3,10.252v4.109A.687.687,0,0,0,3.685,15.046ZM3,3.4V7.513a.687.687,0,0,0,.685.685H7.794a.687.687,0,0,0,.685-.685V3.4a.687.687,0,0,0-.685-.685H3.685A.687.687,0,0,0,3,3.4Zm8.869-1.1-2.911,2.9a.682.682,0,0,0,0,.966l2.911,2.911a.682.682,0,0,0,.966,0l2.911-2.911a.682.682,0,0,0,0-.966l-2.9-2.9a.69.69,0,0,0-.972,0Z" transform="translate(-3 -2.108)" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'ComponentsIcon'
  }
</script>

<style>
  .components-icon {
    margin-right: 10px;
  }
</style>